import CryptoJS from 'crypto-js';

export const DES_KEY = "VjuIrWa2UlieBUw87/whTw==";

export const SIGN_KEY = "xVgPwIPBzCCzrif6rGReMsPn";

/**
 * DES加密
 * 转Utf8编码: CryptoJS.enc.Utf8.parse();
 * 转Base64: CryptoJS.enc.Base64.stringify();
 * @param data 需要加密的数据
 * @param key 密钥
 * @returns 加密后的数据
 */
export const encodeDES = (data) => {
  const dataObj = typeof data === 'string' ? JSON.parse(data) : data;
  // const lastObj = {
  //   sign: CryptoJS.MD5(`${JSON.stringify(dataObj)}${SIGN_KEY}`).toString(),
  //   data: dataObj
  // };
  // console.log(JSON.stringify(dataObj));
  const result = CryptoJS.TripleDES.encrypt(JSON.stringify(dataObj), CryptoJS.enc.Utf8.parse(DES_KEY), {
    // const result = CryptoJS.TripleDES.encrypt((dataObj), CryptoJS.enc.Utf8.parse(DES_KEY), {
    // iv: CryptoJS.enc.Utf8.parse('xx'), // 向量。使用CBC模式时，需要使用向量。
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7 // 偏移量。使用非补码方式时，需要使用ZeroPadding。默认为PKCS5Padding。
  });
  return CryptoJS.enc.Base64.stringify(result.ciphertext); // base64转码
}

/**
 * DES解密
 * @param data 需要解密的数据
 * @param key 密钥
 * @returns 解密后的数据
 */
export const decodeDES = (data, key = DES_KEY) => {
  if (typeof data !== 'string') {
    data = JSON.stringify(data);
  }

  const result = CryptoJS.TripleDES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
    // iv: CryptoJS.enc.Utf8.parse('xx'), // 向量。使用CBC模式时，需要使用向量。
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7 // 偏移量。使用非补码方式时，需要使用ZeroPadding。默认为PKCS5Padding。
  });
  return CryptoJS.enc.Utf8.stringify(result); // 转为utf-8编码
}

export const resultVerify = (data) => {
  const res = typeof data.data === 'string' ? data.data : JSON.stringify(data.data);
  return CryptoJS.MD5(`${res}${SIGN_KEY}`).toString() === data.sign;
}


export const getSign = (data, date) => {
  const obj = {
    nonce: '123456',
    timestamp: date,
    sysid: '701',
    signkey: SIGN_KEY,
    paramjson: data
  }
  const nObj = ObjSort(obj)
  // console.log(nObj)
  let sign = ''
  for (const key in nObj) {
    sign += key + nObj[key];
  }
  // console.log(sign)
  return CryptoJS.MD5(sign).toString()
}

const ObjSort = function (arys) {
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newkey = Object.keys(arys).sort();
  //console.log('newkey='+newkey);
  var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) {
    //遍历newkey数组
    newObj[newkey[i]] = arys[newkey[i]];
    //向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj; //返回排好序的新对象
}
